import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function RoutedThroughIVRMenu({ node }) {
    return (_jsxs(_Fragment, { children: ["IVR \u00B7", ' ', node.button ? (_jsxs(_Fragment, { children: ["Pressed ", _jsx("strong", { children: node.button })] })) : ('No response')] }));
}
